import { render, staticRenderFns } from "./BoardActionsMenu.vue?vue&type=template&id=bc036690&"
import script from "./BoardActionsMenu.vue?vue&type=script&lang=js&"
export * from "./BoardActionsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports